// MUI Autocomplete's groupBy only merges adjacent options, so a group split across the list renders its header twice.
export const groupOptionsContiguously = <T>(options: T[], groupOf: (option: T) => string): T[] => {
  const optionsByGroup = new Map<string, T[]>()
  options.forEach(option => {
    const group = groupOf(option)
    optionsByGroup.set(group, [...(optionsByGroup.get(group) ?? []), option])
  })
  return [...optionsByGroup.values()].flat()
}
